// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

const LEGACY_DOMAIN = 'hanggent.com';
const CURRENT_DOMAIN = 'hangent.com';

/**
 * The product moved from hanggent.com to hangent.com; API calls sent to the
 * old domain hit a 301 that browsers do not follow for POST. Returns the URL
 * on the current domain, or null when the page is not on the old one.
 * Only the host is compared, never the rest of the URL.
 */
export function getLegacyHostRedirect(href: string): string | null {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  const host = url.hostname;
  if (host !== LEGACY_DOMAIN && !host.endsWith(`.${LEGACY_DOMAIN}`)) {
    return null;
  }
  url.hostname = host.slice(0, host.length - LEGACY_DOMAIN.length) + CURRENT_DOMAIN;
  return url.toString();
}
